import { isLoginNoteIconKey, type LoginNoteIconKey } from "./loginNoteIcons";

export type LoginNote = {
  title: string;
  subtitle: string;
  icon: LoginNoteIconKey;
};

type LoginNoteInput = {
  title: string;
  subtitle: string;
  icon: string;
};

const DEFAULT_LOGIN_NOTE_ICON: LoginNoteIconKey = "view_in_ar";

export const normalizeLoginNote = (note: LoginNoteInput): LoginNote => ({
  title: note.title,
  subtitle: note.subtitle,
  icon: isLoginNoteIconKey(note.icon) ? note.icon : DEFAULT_LOGIN_NOTE_ICON,
});

export const pickRandomLoginNote = (
  notes: readonly LoginNoteInput[],
  randomValue = Math.random(),
): LoginNote => {
  if (notes.length === 0) {
    throw new Error("loginNotes must not be empty");
  }

  const index = Math.floor(randomValue * notes.length);
  return normalizeLoginNote(notes[Math.min(index, notes.length - 1)]);
};
